import Restraint from "./Restraint.js";
import {v3} from "oc-threejs/short3.js";
import Scenes from "oc-threejs/Scenes";
import AnchorAwareMixin from "./AnchorAwareMixin";
import Cylinder from "oc-threejs/math/Cylinder";

/**
 * Positioniert das Objekt auf einer Linie, falls es einen bestimmten Abstand dazu unterschreitet
 */
export default class LineRestraint extends AnchorAwareMixin(Restraint) {

    /** @type {THREE.Line3} */
    line;
    /** @type {number} */
    radius;
    // @deprecated synonym für options.freeOrientation
    /** @type {boolean} */
    freeOrientationAroundMainAxis;

    constructor(options) {
        super(options);
        this.line = options.line || new THREE.Line3(v3(-1000,0,0),v3(1000,0,0));
        this.radius = options.radius || 1;
        this.freeOrientation = options.freeOrientation || options.freeOrientationAroundMainAxis || false;
    }

    /**
     * @param {THREE.Ray} ray
     * @returns {?THREE.Vector3}
     */
    raycastLocal(ray) {
        const pointOnRay = v3();
        const point = v3();
        ray.distanceSqToSegment(this.line.start, this.line.end, pointOnRay, point);
        const distance = point.distanceTo(pointOnRay);
        if (distance<this.radius) {
            return point;
        }
        return null;
    }

    /**
     * @param {THREE.Raycaster} raycaster
     * @param {THREE.Vector3} point
     * @param {boolean} dropped
     */
    perform(raycaster, point, dropped) {
        if (this.freeOrientation) {
            Scenes.bring({
                what: [this.dragObject3d,this.anchorMatrix,v3(0,1,0)],
                to: [this.matrixWorld,this.line.delta()],
                rotate: true,
            });
        } else {
            Scenes.bring({
                what: [this.dragObject3d,this.anchorMatrix],
                to: [this.matrixWorld],
                rotate: true,
            });
        }
        Scenes.bring({
            what: [this.dragObject3d,this.anchorMatrix],
            to: [point],
            translate: true,
        });
    }

    setDefaultAnchorMatrix() {
        this.anchorMatrix = new THREE.Matrix4();
    }

    createDebugVisualization() {
        const group = new THREE.Group();
        const r = Number.isFinite(this.radius) ? this.radius : 1;
        group.add(Scenes.cylinder(
            new Cylinder().setFromLineAndRadius(this.line,r), {
                color: STAGE.settings.dragDrop.restraintsDebugColor,
                linewidth: 1,
                wireframe: true,
            }));
        return group;
    }

}
